export const GET_IMAGES = "GET_IMAGES";
export const GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS";
export const GET_IMAGES_ERROR = "GET_IMAGES_ERROR";

export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";

export const REMOVE_IMAGES = "REMOVE_IMAGES";

export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";

export const SET_VIEWER = "SET_VIEWER";
